module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PROSERPINA_STYLE.3f57137b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PROSERPINA_STYLE.png
// module id = 1172
// module chunks = 16